import { useState } from "react";
import Review from "../../../core/review";
import ReviewDetailsModal from "./reviewDetailsModal";
import { IReview } from "./reviews";
import { IRequest } from "./requests";
import AdminButton from "../../../core/admin/adminButton";
import AdminBadge from "../../../core/admin/adminBadge";

export default function ReviewsList({ reviews, requests, refresh, goodToast, badToast }: { reviews: IReview[] | null, requests: IRequest[] | null, refresh: () => Promise<null>, goodToast: () => void, badToast: () => void }) {

    const [modal, setModal] = useState(false);
    const [editableReview, setEditableReview] = useState<IReview | null>(null);

    if (!reviews || !reviews.length) {
        return null;
    }

    const handleEditModal = (r: IReview) => {
        setEditableReview(r)
        setModal(true);
    }

    const isRequest = (review: IReview) => {
        const req: IRequest[] | undefined = requests?.filter(r => r.review === review.id);
        if(req?.length && req[0]?.solved){
            return {message: "Solicitação resolvida", color: "green"};
        }
        if(req?.length && !req[0]?.solved){
            return {message: "Solicitação aberta", color: "red"};
        }
        return {message: "", color: "green"};
    }

    return (
        <div>
            <p className="text-sm text-gray-500 mb-3">{reviews.length} {reviews.length === 1 ? "avaliação encontrada" : "avaliações encontradas"}</p>
            <ul className="flex flex-col gap-3">
                {
                    reviews.map((r, i) => (
                        <li key={i} className="flex flex-col md:flex-row gap-4 rounded-xl border border-gray-200 bg-white p-4">
                            <div className="flex-1 min-w-0">
                                <Review review={r} />
                            </div>
                            <div className="flex md:flex-col items-center md:items-end justify-between gap-2 border-t border-gray-100 pt-3 md:border-0 md:pt-0 md:w-48 shrink-0">
                                <div className="flex flex-wrap gap-1.5 md:justify-end">
                                    {
                                        r.hidden ?
                                            <AdminBadge tone="danger" dot>Escondida</AdminBadge>
                                            : <AdminBadge tone="success" dot>Visível</AdminBadge>
                                    }
                                    {
                                        r.hidden || isRequest(r).color === "red" ?
                                            isRequest(r).message ?
                                                <AdminBadge tone={isRequest(r).color === "red" ? "warning" : "neutral"}>{isRequest(r).message}</AdminBadge>
                                                : null
                                            : null
                                    }
                                </div>
                                <AdminButton size="sm" variant="secondary" onClick={() => handleEditModal(r)}>Detalhes</AdminButton>
                            </div>
                        </li>
                    ))
                }
            </ul>
            {
                modal && editableReview ?
                    <ReviewDetailsModal close={() => setModal(false)} review={editableReview} goodToast={goodToast} badToast={badToast} refresh={refresh}/>
                    : null
            }
        </div>
    )
}
